module.exports = "/_next/static/pages/test-guidelines/4e0b5b63fab2317df3cc27a0ddf491e2.png";